import React from 'react';
import { Link } from 'react-router-dom';



import { getEnv } from '../../../../lib/utils/getEnv';


const { VITE_HELP_CENTRE_URL } = getEnv();

export const faqsConfig = [
  {
    question: 'What makes Pata the right booking software for pet groomers?',
    answer: () => (
      <>
        <p>
          Pata is built specifically for pet groomers and other pet care professionals. Our unique{' '}
          <Link to="/business/features">features </Link>
          help organise bookings, reduce admin and no-shows, and attract new clients — all in one place.
        </p>
        <p>
          Whether you’re a mobile groomer or run a multi-location salon, you get full access to an intuitive booking
          platform without monthly fees, designed to help streamline your business and run your calendar with ease.
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata a good fit for all business sizes?',
    answer: () => (
      <>
        <p>
          Pata is built for pet grooming businesses of every size, from solo and mobile groomers to busy salons with
          multiple locations. Whether you’re just starting out or expanding to different branches, Pata helps you take
          online bookings, manage appointments and minimise no-shows.
        </p>

        <p>
          You’ll get access to the same powerful tools no matter your size, including online booking, automated
          reminders and calendar management. The platform is subscription-free and flexible, so you can grow at your own
          pace without monthly fees.
        </p>
      </>
    ),
  },
  {
    question: 'How can Pata help my pet grooming business reduce no-shows?',
    answer: () => (
      <>
        <p>
          Pata helps reduce no-shows and cancellations with smart booking features designed for pet grooming businesses.
          You can request deposits or collect client payment cards using <Link to="/business/pata-pay">PataPay</Link>,
          which adds commitment from clients and protects your time.
        </p>

        <p>
          To keep your schedule full, Pata also offers automated reminders, waitlists, and smart scheduling. These
          features help you fill gaps quickly with clients who most suit the empty slot, and spend less time chasing
          late or missed appointments.
        </p>
      </>
    ),
  },
  {
    question: 'Do I need technical skills to use Pata?',
    answer: () => (
      <>
        <p>
          Not at all. Pata booking platform is designed to be simple and intuitive so you don’t need any technical
          skills to find your way around and start simplifying your admin.
        </p>

        <p>
          Whether you’re familiar with pen and paper diaries or another booking platform, setting up your business on
          Pata is quick and simple.
        </p>

        <p>
          If you do need help though, our dedicated support team is always on hand to answer your questions, and you can
          find lots of detailed information in our{' '}
          <a href={`${VITE_HELP_CENTRE_URL}`} target="_blank">
            Help Centre
          </a>
          .
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata really subscription-free?',
    answer: () => (
      <>
        <p>
          In short, yes! We think every pet grooming business should be able to access digital tools which simplify
          tedious admin tasks, so we made our booking platform subscription-free.
        </p>

        <p>
          With Pata, you get access to unlimited appointment bookings, client and email notifications, locations, and
          team members — all without any upfront or monthly fees.
        </p>

        <p>
          If you want to go further, extras like SMS top-ups and online or in-person payments are available — but
          they’re completely optional.
        </p>
      </>
    ),
  },
  {
    question: 'How does Pata Marketplace help promote pet grooming businesses?',
    answer: () => (
      <>
        <p>
          Joining Pata, you gain access to Pata Marketplace — a pet owners one-stop-shop for finding trusted local pet
          businesses.
        </p>

        <p>
          Pata Marketplace boosts your visibility online by helping pet owners discover pet care businesses when
          searching on Pata or Google for local pet services like grooming, walking, sitting, or training.
        </p>

        <p>
          Having a presence on Marketplace not only promotes your pet grooming business to local pet owners, but also
          helps grow your current network of loyal pet owners.
        </p>
      </>
    ),
  },
  {
    question: 'Can I migrate my data from my previous platform to Pata?',
    answer: () => (
      <>
        <p>
          Yes, if you’re currently using another booking platform, we can support you in migrating key data such as
          client details, appointments, services, and staff schedules into Pata’s booking platform.
        </p>
      </>
    ),
  },
  {
    question: 'Can my clients book appointments online?',
    answer: () => (
      <>
        <p>
          With Pata booking platform, you are in control of your appointments, giving you the option to take bookings
          online or simply use the calendar as a digital diary.
        </p>
        <p>
          With online bookings enabled, customers get 24/7 access to your schedule, meaning fewer calls for you and a
          seamless experience for them. You can also decide whether to accept online bookings from new customers, or
          existing clients only.
        </p>
        <p>No matter how you prefer to take bookings, Pata has flexible features to suit your business needs.</p>
      </>
    ),
  },
  {
    question: 'Can I take upfront payments for grooming appointments?',
    answer: () => (
      <>
        <p>
          Absolutely you can. Taking an upfront payment is a proven way to reduce no-shows and late cancellations for
          pet care businesses, so Pata makes it easy to do just that.
        </p>
        <p>
          Once online payments are enabled, you can set a custom deposit amount or request full payments in advance. You
          can also collect clients’ card details in case of any no-show or late cancellation charges, giving you control
          of your income and protecting your time.
        </p>
      </>
    ),
  },
];